import { render, staticRenderFns } from "./BrowserModal.vue?vue&type=template&id=0cc12a47&"
import script from "./BrowserModal.vue?vue&type=script&lang=js&"
export * from "./BrowserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports